import { render } from "./usersBatchSetLoss.vue?vue&type=template&id=36763f3c&scoped=true"
import script from "./usersBatchSetLoss.vue?vue&type=script&lang=js"
export * from "./usersBatchSetLoss.vue?vue&type=script&lang=js"

import "./usersBatchSetLoss.vue?vue&type=style&index=0&id=36763f3c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36763f3c"]])

export default __exports__